import { OptionOf } from '~/components/molecule/Dropdown';
import { setTextStyle } from '~/components/organism/PluginsEditor/commands/modify/text';
import { DHEditor } from '~/components/organism/PluginsEditor/types';

const fontSizes: Array<number> = [
  8, 10, 12, 14, 16, 18, 20, 22, 24, 28, 30, 32, 36, 40, 48, 56, 60, 64, 72, 80,
  96,
];

const getFontSizeOptions = (editor: DHEditor): Array<OptionOf<number>> =>
  fontSizes.map(item => ({
    key: item,
    label: item,
    payload: item,
    onClickAction: () => setTextStyle(editor, 'fontSize', `${item}px`),
  }));

export default getFontSizeOptions;
